import { createPurchaseRequest } from '../hooks/purchase-request';
import type { AddonPurchaseData, AddonPurchaseResult } from './addon-purchase-panel';

export const addonPurchaseRequest = createPurchaseRequest<AddonPurchaseData, AddonPurchaseResult>();
